import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setTrackDesignChangesReducer = (state: EditorState, action: PayloadAction<boolean>) => {
  state.trackDesignChanges = action.payload;
};

export default setTrackDesignChangesReducer;
